import type { ReactElement } from 'react';

import inputClasses from '../Inputs.module.css';

export const Label = (
    props: {
        label: ReactElement | string;
        /** Additional element to render to the right (right-aligned) to of the label. */
        labelRight?: ReactElement | string;
        style?: React.CSSProperties;
        /** Whether to render indicator for required field */
        required?: boolean;
    } & Pick<JSX.IntrinsicElements['label'], 'className' | 'htmlFor'>
) => (
    <label className={props.className} style={props.style} htmlFor={props.htmlFor}>
        {props.label}
        {props.required && <span>&nbsp;&nbsp;*</span>}
        <div className={inputClasses.labelRight}>{props.labelRight}</div>
    </label>
);

export default Label;
